// removed by extract-text-webpack-plugin
module.exports = {"Element":"_3E1d18bV-On5tnr06tR8Jw","Name":"_1NjPKW2loJi0tMSNurFf-z","FirstCol":"_2hlmFYCNin4_07uPy9l9Kq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Detail/ArticleElement/ArticleElement.css
// module id = 394
// module chunks = 0